<ag-progress-list
  [requestObject]="requestObject"
  [disableDetailFullScreen]="true"
  [disableBulkUpdateButton]="true"
  [student]="student"
  (errorGetList)="errorGetListCallback($event)"
></ag-progress-list>
